<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Modelo de Orçamentos</h3>
        <router-link class="btn btn-success text-white float-right " href="/admin/orcamentos/modelo/novo">Novo modelo</router-link>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Modelos</h6>
            </div>
            <div class="col-6">
              <form action="#" class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <quotation-table :is-model="true" :quotations="quotations.list"></quotation-table>
            </div>
            <pagination :total-items="quotations.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import QuotationTable from '../components/QuotationListTable.vue';

export default {
  name: 'quotation-model-list',
  components: {
    Pagination,
    QuotationTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    quotations() {
      const { modelList } = this.$store.state.quotation;
      if (modelList && modelList.list.length) {
        return modelList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getModelList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getModelList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  min-height: 20vh;
}
</style>
